import { normalizeDate } from './parser'

export function textOf (selector: string, root: ParentNode = document): string {
  const el = root.querySelector<HTMLElement>(selector)
  return el?.innerText?.trim() || ''
}

export function createLinkPill (text: string, href: string, style: string): HTMLAnchorElement {
  const link = document.createElement('a')
  link.innerHTML = text
  link.href = href
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  link.style.cssText = style
  return link
}

export function sanitizeFilename (name: string): string {
  return name.replace(/[:/\\?%*|"<>]/g, '_')
}

export function parsePublicationDate (pubDate: string): string | null {
  if (!pubDate) return null
  const result = normalizeDate(pubDate)
  // Only return if normalizeDate produced a valid YYYY-MM-DD date
  return /^\d{4}-\d{2}-\d{2}$/.test(result) ? result : null
}
